import type { TFlightFormValues } from "@/app/lib/types/types";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export const DatesGuard = () => {
  const { setValue, control } = useFormContext<TFlightFormValues>();
  const [departureDate, returnDate] = useWatch({
    control,
    name: ["dates.departure", "dates.return"],
  });

  useEffect(() => {
    if (
      returnDate &&
      departureDate &&
      dayjs(returnDate).isBefore(dayjs(departureDate))
    ) {
      setValue("dates.return", departureDate);
    }
  }, [departureDate, returnDate, setValue]);

  return null;
};
